<template>
  <div class="panier-page">
    <div class="panier-title">
      <h1> MON PANIER </h1>
      <div class="breadcrumb">
        <a href="/" style="color: white;">Accueil</a> ><a href="/vitamines-mineraux" style="color: white;">Vitamines & Minéraux</a>> <a href="/Mon panier" style="color: white;">Mon panier</a>
      </div>
    </div>
    <div class="panier-content">
     <!--<p>Voici les articles que vous avez ajoutés à votre panier.</p>--> 
      
      <!-- Section du produit -->
      <div class="product-list">
        <div class="product-item">
          <div class="product-image">
            <!-- Remplace cette ligne par le chemin de ton image de produit -->
            <img src="@/assets/vit D.jpg" alt="Produit" />
          </div>
          <div class="product-details">
            <h2>Vitamine D</h2>
            <p><strong>Prix : 0,00 MAD</strong></p>
            <button @click="acheterProduit">Acheter maintenant</button>
          </div>
        </div>

        <!-- Exemple d'un deuxième produit 
        <div class="product-item">
          <div class="product-image">
            <img src="@/assets/bandage.jpg" alt="Produit" />
          </div>
          <div class="product-details">
            <h2>Produit 2</h2>
            <p>Description du produit :</p>
            <p>Ce produit est un autre exemple pour vos besoins en laboratoire.</p>
            <p><strong>Prix : 150,00 €</strong></p>
            <button @click="acheterProduit">Acheter maintenant</button>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanierI',
  methods: {
    acheterProduit() {
      alert('Produit ajouté au panier !');
    }
  }
};
</script>

<style scoped>
.panier-page {
  padding: 0px 0px;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.panier-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/vitaa.jpeg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 150px 300px;
  font-size: 16px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}
.breadcrumb {
  font-size: 12px;
  color: #e9e3e3;
  margin-top: 20px;
}

.breadcrumb a {
  color: #0c0c0c;
  text-decoration: none;
  font-weight: bold;
}

.breadcrumb a:hover {
  text-decoration: underline;
}
.panier-title h1 {
  margin: 0;
  color: rgb(240, 237, 237);
}

.panier-content {
  margin-top: 0px;
  padding: 50px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.panier-content p {
  font-size: 18px;
  color: #333;
}

/* Conteneur pour la liste des produits */
.product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Aligner les produits à gauche */
  gap: 20px; /* Espacement entre les produits */
}

/* Style pour chaque produit */
.product-item {
  background-color: #f5f5f5;
  border: 1px solid #ddd; /* Petite bordure autour du produit */
  border-radius: 8px;
  width: calc(33.33% - 20px); /* Permet de mettre 3 produits par ligne */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}

.product-image img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.product-details {
  margin-top: 20px;
}

.product-details h2 {
  font-size: 20px;
  margin-bottom: 10px;
}

.product-details p {
  font-size: 14px;
  margin-bottom: 10px;
}

.product-details button {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.product-details button:hover {
  background-color: #45a049;
}


</style>
